import React, { useContext, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import _ from 'lodash';
import { summaryDrilldownData, updatePlan } from 'gqlQueries/promoRecommendation';
import { summaryDataParser } from 'parser/promoRecommendation';
import { UserContext } from 'contexts/ConfigContext';
import { colorConstants } from 'config/colorConstants';
import { getSummaryDrillDownExportData } from 'parser/graphToExcelDownloadParser';

const errorMessage: string = 'Something went wrong!';
const groupedColor: [string, string] = [colorConstants.cyan, colorConstants.blue];

function useFetchSummaryDrilldownData() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any>(null);
    const [exportData, setExportData] = useState<any>(null);
    const { appConfig } = useContext(UserContext);

    const [fetchSummaryData, { data: eventsListData, loading: eventsListDataLoading, error: eventsListDataError }] =
        useLazyQuery(summaryDrilldownData, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPlansSummaryGraph } = payload;
            if (getPlansSummaryGraph && Array.isArray(getPlansSummaryGraph?.data)) {
                if (getPlansSummaryGraph?.data?.length === 0) throw 'No Data';
                const { distinctPlans = [] } = getPlansSummaryGraph;
                let parsedData: any[] = [];
                let minVal = 0;
                let maxVal = 0;
                let legend: any[] = [];
                legend = distinctPlans.map((item: any, idx: number) => {
                    return {
                        color: idx === 0 ? groupedColor[0] : groupedColor[1],
                        label: item,
                    };
                });
                getPlansSummaryGraph?.data?.forEach((item: any, idx: number) => {
                    minVal = Math.min(item?.value, minVal);
                    maxVal = Math.max(item?.value, maxVal);
                    const tempObj = {
                        category: item?.attributeName,
                        type: item?.type,
                        sales: item?.value,
                        color:
                            distinctPlans?.length === 1
                                ? groupedColor[0]
                                : idx % 2 === 0
                                ? groupedColor[0]
                                : groupedColor[1],
                    };
                    parsedData.push(tempObj);
                    if (distinctPlans?.length === 1) {
                        parsedData.push({
                            category: item?.attributeName,
                            type: 'dummyType',
                            sales: item?.value,
                            color: groupedColor[0],
                        });
                    }
                });
                const tempExportData = getSummaryDrillDownExportData(getPlansSummaryGraph?.data, distinctPlans);
                setExportData(tempExportData);
                setData({ minVal, maxVal, legend, chartData: parsedData });
            }
            //if data present parse it
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setLoading(false);
        setData(null);
        setExportData(null);
        setError(String(error));
    }

    return {
        loading,
        error,
        data,
        exportData,
        fetchDrilldownData: (variables: any) => {
            setError(null);
            setLoading(true);
            setData(null);
            setExportData(null);
            fetchSummaryData(variables);
        },
    };
}

export { useFetchSummaryDrilldownData };
